var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41672_58046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 9.75L9.275 8.475L15.125 2.625C15.6082 2.14175 15.6082 1.35825 15.125 0.875V0.875C14.6418 0.391751 13.8582 0.391751 13.375 0.875L7.525 6.725L6.25 9.75Z",
    fill: "#2CB2A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.85 9.325L9.675 9.4L6.65 10.675L4.4 11.6L5.325 9.35L6.6 6.325L6.675 6.15L6.825 6L10.325 2.5H3C1.34314 2.5 0 3.84315 0 5.5V13C0 14.6569 1.34315 16 3 16H10.5C12.1569 16 13.5 14.6569 13.5 13V5.675L10 9.175L9.85 9.325Z",
    fill: "#2CB2A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41672_58046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote2);
export default __webpack_public_path__ + "static/media/note2.25bde17d.svg";
export { ForwardRef as ReactComponent };